import { render, staticRenderFns } from "./NormalSearchNav286.vue?vue&type=template&id=2448c644&scoped=true"
import script from "./NormalSearchNav286.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav286.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448c644",
  null
  
)

export default component.exports